<script type="text/ecmascript-6">
    import DesignerQuestionDoorRange from "./DesignerQuestionDoorRange.vue";

    export default {
        mixins: [
            DesignerQuestionDoorRange
        ],
        computed: {
            thumbURL(){
                return '/images/s/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/door-range?fabricator_id=3';
            },
        },
    }
</script>
